//data-test-id
import React, { useState } from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'

import { PageHeader } from 'src/components/Ant'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from './styles'
import ApprovalFlow from './approvals'
import ClosingFlow from './closings'
import ConferenceFlow from './conferences'

export default function FlowManagement() {
  useDocumentTitle('web.policies-flow.title')

  const [activeKey, setActiveKey] = useState<string>('approvals')
  const { t } = useTranslation()

  return (
    <>
      <PageHeader title="web.policies-flow.title" />
      <CSS.Container>
        <Tabs
          activeKey={activeKey}
          data-test-id="air-result-panel-card"
          defaultActiveKey="approvals"
          onChange={activeK => {
            setActiveKey(activeK)
          }}
          tabBarStyle={{ textAlign: 'center' }}
          type="card"
        >
          <CSS.TabPane
            data-test-id="approvals"
            key="approvals"
            tab={t('web.policies-flow.approval.title')}
          >
            <ApprovalFlow />
          </CSS.TabPane>
          <CSS.TabPane
            data-test-id="conferences"
            key="conferences"
            tab={t('web.policies-flow.conference.title')}
          >
            <ConferenceFlow />
          </CSS.TabPane>
          <CSS.TabPane
            data-test-id="closings"
            key="closings"
            tab={t('web.policies-flow.closing.title')}
          >
            <ClosingFlow />
          </CSS.TabPane>
        </Tabs>
      </CSS.Container>
    </>
  )
}
